<template>
  <!--我的收货地址-->
  <div id="addresslist">
    <h2 class="title">
      <a @click="back()" class="prev"></a>
      我的收货地址
      <a @click="gotoAddEdit" class="add">添加地址</a>
    </h2>
    <ul>
      <!--
      <li>
        <a href="" class="dz">
          <b>静静</b><i>18298550030</i><br>
          <p><label>默认地址</label>北京市西城区新外大街8号金丰和商务苑A座526室</p>
        </a>
        <span></span>
        <a href="" class="edit">编辑</a>
      </li>
      -->
      <li v-for="(item, index) in addressData" :key="index">
        <a @click="setDefault(item.add_id)" class="dz">
          <b>{{item.name}}</b><i>{{item.phone}}</i><br>
          <p><label v-if="item.default">默认地址 </label>{{item.province}}{{item.city}}{{item.county}}{{item.address}}</p>
        </a>
        <span></span>
        <router-link :to="{name: 'AddressEdit', query: {address_id: item.add_id}}" class="edit">编辑</router-link>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'AddressList',
  data () {
    return {
      addressData: {},
      page: 1,
      length: 20,
      addressId: 0
    }
  },
  mounted () {
    this.getAddressList()
  },
  methods: {
    getAddressList () {
      let data = {
        page: this.page,
        length: this.length
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_order_all_receiving_address',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.addressData = res.data.data.info
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    postDefault () {
      let data = {
        address_id: this.addressId,
        is_default: 1
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_update_default_address',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.back()
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    setDefault (id) {
      this.addressId = id
      this.postDefault()
    },
    gotoAddEdit () {
      this.$router.push({name: 'AddressEdit'})
    }
  }
}
</script>

<style scoped lang="stylus">
#addresslist
  .title
    position: relative
    height: 1.08rem
    line-height: .8rem
    background-color: transparent
    padding: .14rem .16rem
    font-size: .32rem
    color: #050505
    font-weight: 600
    text-align: center
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: #fff
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #050505
        border-bottom: .03rem solid #050505
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
    a.add
      position: absolute
      top: .14rem
      right: .4rem
      font-size: .28rem
      color: #9DA4B3
      font-weight: 400
  ul
    padding: 0 .4rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    li
      display: flex
      justify-content: space-between
      align-items: center
      margin-top: .52rem
      a.dz
        display: inline-block
        width: 5.62rem
        b
          display: inline-block
          margin: 0 .2rem .08rem 0
          font-size: .32rem
          color: #333
        i
          font-size: .24rem
          color: #666
          font-style: normal
        p
          font-size: .2rem
          color: #4d4d4d
          label
            font-size: .18rem
            color: #2283f3
      span
        display: inline-block
        width: .04rem
        height: .48rem
        background-color: #CFD1D4
      a.edit
        font-size: .24rem
        color: #666
</style>



// WEBPACK FOOTER //
// src/components/personal/AddressList.vue